import { EVENT_TYPE } from '../../model/events';

export const GRAPHQL_GATEWAY_PATH = '/gateway/api/graphql';

export interface Container {
  name: string;
}

export interface Contributor {
  accountID: string;
  name?: string;
  picture: string;
}

export interface ObjectItem {
  cloudID: string;
  iconURL: string;
  id: string;
  name: string;
  product: string; // right now this could be 'jira'
  url: string;
}

export interface ActivityItem {
  container: Container;
  contributors: Contributor[];
  eventType: EVENT_TYPE;
  object: ObjectItem;
  timestamp: string;
}

export interface GraphQLRequest {
  operationName?: string;
  query: string;
  variables?: {};
}
